
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticProps } from 'next';
import { SUPPORTED_LOCALES, SupportedLocale } from 'i18n';
import { BlogHomePage } from 'modules/blog/pages/BlogHomePage';
import { MarketplaceAPI } from 'revibe-api';
export default BlogHomePage;
const getStaticProps: GetStaticProps = async ({ locale }) => {
    const { data: articles } = await MarketplaceAPI.getBlogArticles((locale as SupportedLocale) || SUPPORTED_LOCALES.EN);
    const { data: categories } = await MarketplaceAPI.getBlogCategories((locale as SupportedLocale) || SUPPORTED_LOCALES.EN);
    return {
        props: {
            articles: Array.isArray(articles) ? articles : [],
            categories: Array.isArray(categories) ? categories : [],
        },
        revalidate: 60,
    };
};

    async function __Next_Translate__getStaticProps__18c6845d6ec__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/blog/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18c6845d6ec__ as getStaticProps }
  